import { render, staticRenderFns } from "./practice-class-card.component.vue?vue&type=template&id=6dd8ab78&scoped=true"
import script from "./practice-class-card.component.vue?vue&type=script&lang=js"
export * from "./practice-class-card.component.vue?vue&type=script&lang=js"
import style0 from "./practice-class-card.component.vue?vue&type=style&index=0&id=6dd8ab78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8ab78",
  null
  
)

export default component.exports